export default "__VITE_ASSET__d454e07d__"